module.exports = __webpack_public_path__ + "img/erp.74874a68.jpg";